import React from 'react'
import RegioDetailsContent from '../../../components/Dashboard/RegionsListContent/View';
import { Link } from 'react-router-dom';

function RegionDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Region Details</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>eCommerce</li>
              <li>Regions</li>
              <li>Regions Details</li>
            </ul>
          </div>
            */}
          <RegioDetailsContent />
        </>
      );
}

export default RegionDetails
